import { DataState } from "Models/Common/DataState";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import { TaskTemplateTag } from "Models/Tasks/TaskTemplateTag";
import { TaskTemplateFilterState } from "./TaskTemplateFilterState";

export interface ITaskTemplateState {
    currentFilter: TaskTemplateFilterState;
    taskTemplates?: TaskTemplate[];
    taskTemplateTags?: TaskTemplateTag[];
    totalTasks?: number;
    isLoading: boolean;
    detailTaskTemplates: { [taskTemplateId: number]: TaskTemplate };
    detailTaskTemplateStates: { [taskTemplateId: number]: DataState };
    detailTaskTemplateValidationErrors: { [taskTemplateId: number]: string[] };

    currentArrangeFilter: TaskTemplateFilterState;
    arrangeTaskTemplates?: TaskTemplate[];
    isArrangeLoading: boolean;
}

export class TaskTemplateState implements ITaskTemplateState {
    public currentFilter: TaskTemplateFilterState;
    public taskTemplates = [];
    public isLoading: boolean = false;
    public detailTaskTemplates = {};
    public detailTaskTemplateStates = {};
    public detailTaskTemplateValidationErrors = {};

    public currentArrangeFilter: TaskTemplateFilterState = new TaskTemplateFilterState();
    public arrangeTaskTemplates = [];
    public isArrangeLoading: boolean = false;
}


// WEBPACK FOOTER //
// ./src/Store/TaskTemplates/TaskTemplateState.ts